import { SIZE_DISPLAY_GROUP } from 'Component/ProductOptions/ProductOptions.config';

/** @namespace Bodypwa/Util/Product/Placement/parseEntryPoint */
export const parseEntryPoint = (search, hash, configOptions) => {
    const params = new URLSearchParams(search || '');
    const hashParams = new URLSearchParams((hash || '').slice(1));
    const sku = params.get('sku') || null;
    const placement = hashParams.get('placement') || null;
    const colorParams = {};
    const sizeParams = {};

    for (const [key, val] of params.entries()) {
        if (key !== 'sku') {
            const opt = configOptions[key];
            if (opt) {
                if (opt.attribute_display_group === SIZE_DISPLAY_GROUP) {
                    sizeParams[key] = val;
                } else {
                    colorParams[key] = val;
                }
            }
        }
    }

    for (const [key, val] of hashParams.entries()) {
        if (key !== 'placement') {
            const opt = configOptions[key];
            if (opt) {
                if (opt.attribute_display_group === SIZE_DISPLAY_GROUP) {
                    sizeParams[key] = val;
                } else {
                    colorParams[key] = val;
                }
            }
        }
    }

    return {
        sku,
        placement,
        colorParams,
        sizeParams
    };
};

/** @namespace Bodypwa/Util/Product/Placement/sortPlacementRules */
export const sortPlacementRules = (rules, attributeOptionsOrder) => {
    if (!rules) {
        return rules;
    }

    return [...rules].sort((a, b) => {
        const aIdx = attributeOptionsOrder?.indexOf(String(a.trigger_value_index)) ?? -1;
        const bIdx = attributeOptionsOrder?.indexOf(String(b.trigger_value_index)) ?? -1;

        return (aIdx === -1 ? Infinity : aIdx) - (bIdx === -1 ? Infinity : bIdx);
    });
};
